/* Growplay regional BNPL. All offer text and disclosures come from provider SDKs. */
(() => {
  'use strict';
  if (customElements.get('gp-bnpl')) return;
  const scripts = new Map();
  const currencies = { au: 'AUD', nz: 'NZD', uk: 'GBP', usa: 'USD' };
  function loadScript(src, attributes = {}) {
    if (scripts.has(src)) return scripts.get(src);
    const promise = new Promise((resolve, reject) => {
      const existing = [...document.scripts].find(script => script.src === src);
      if (existing) { resolve(); return; }
      const script = document.createElement('script');
      script.src = src;
      script.async = true;
      Object.entries(attributes).forEach(([key, value]) => script.setAttribute(key, value));
      script.onload = resolve;
      script.onerror = reject;
      document.head.append(script);
    });
    scripts.set(src, promise);
    return promise;
  }
  function refreshAffirm() {
    if (!window.affirm) {
      const config = { public_api_key: '8E8D7NCIKV965JRI', script: 'https://cdn1.affirm.com/js/v2/affirm.js', locale: 'en_US', country_code: 'USA' };
      // Affirm's public bootstrap queues readiness until its SDK is available.
      (function(m,g,n,d,a,e,h,c){var b=m[n]||{},k=document.createElement(e),p=document.getElementsByTagName(e)[0],l=function(a,b,c){return function(){a[b]._.push([c,arguments])}};b[d]=l(b,d,'set');var f=b[d];b[a]={};b[a]._=[];f._=[];b._=[];b[a][h]=l(b,a,h);b[c]=function(){b._.push([h,arguments])};a=0;for(c='set add save post open empty reset on off trigger ready setProduct'.split(' ');a<c.length;a++)f[c[a]]=l(b,d,c[a]);for(a=0,c=['get','token','url','items'];a<c.length;a++)f[c[a]]=function(){};k.async=true;k.src=g[e];p.parentNode.insertBefore(k,p);delete g[e];f(g);m[n]=b})(window,config,'affirm','checkout','ui','script','ready','jsReady');
    }
    window.affirm.ui.ready(() => window.affirm.ui.refresh());
  }
  function element(tag, attributes) {
    const node = document.createElement(tag);
    Object.entries(attributes).forEach(([key, value]) => node.setAttribute(key, value));
    return node;
  }
  class GrowplayBnpl extends HTMLElement {
    static get observedAttributes() { return ['data-amount', 'data-currency']; }
    connectedCallback() {
      if (!this.initialized) {
        this.initialized = true;
        this.variants = JSON.parse(this.querySelector('[data-bnpl-variants]')?.textContent || '[]');
        this.querySelector('[data-bnpl-variants]')?.remove();
      }
      this.visibility = new IntersectionObserver(entries => {
        if (entries.some(entry => entry.isIntersecting) && !this.closest('[hidden]')) {
          this.active = true;
          this.visibility.disconnect();
          this.update();
        }
      }, { rootMargin: '250px' });
      this.visibility.observe(this.parentElement);
      if (this.dataset.context === 'product') this.watchPrice();
      this.resize = new ResizeObserver(() => this.align());
      this.resize.observe(this);
    }
    disconnectedCallback() {
      this.visibility?.disconnect(); this.resize?.disconnect(); this.priceObserver?.disconnect();
      this.section?.removeEventListener('change', this.onChange);
      clearTimeout(this.priceTimer); clearTimeout(this.updateTimer); clearInterval(this.readyTimer);
    }
    attributeChangedCallback() {
      if (!this.isConnected || !this.active) return;
      // Hide the previous quote immediately, then replace it at the latest amount.
      this.querySelectorAll('[data-ready]').forEach(offer => offer.removeAttribute('data-ready'));
      clearTimeout(this.updateTimer);
      this.updateTimer = setTimeout(() => this.update(), 120);
    }
    watchPrice() {
      this.section = this.closest('.shopify-section');
      const block = this.closest('.product-block--price, .modal_price') || this.parentElement;
      const ui = block.querySelector('[data-price-ui]');
      const sync = () => {
        const money = ui?.querySelector('[data-price] .money, .gp-frame-standard-price-ui__current .money, .price__current .money');
        if (!money) return;
        const amount = Number(money.textContent.replace(/[^0-9.]/g, ''));
        if (Number.isFinite(amount)) this.amount = Math.round(amount * 100);
      };
      if (ui) {
        this.priceObserver = new MutationObserver(sync);
        this.priceObserver.observe(ui, { childList: true, subtree: true, characterData: true });
        sync();
      }
      this.onChange = () => {
        clearTimeout(this.priceTimer);
        this.priceTimer = setTimeout(() => {
          const input = this.section?.querySelector('form[action*="/cart/add"] [name="id"]');
          const variant = this.variants.find(item => String(item.id) === input?.value);
          if (variant) { this.amount = variant.price; this.dataset.sku = variant.sku || ''; }
          sync();
        }, 100);
      };
      this.section?.addEventListener('change', this.onChange);
    }
    set amount(value) {
      const next = String(value);
      if (this.dataset.amount !== next) this.dataset.amount = next;
    }
    align() {
      const offers = [...this.querySelectorAll('[data-ready]')].filter(node => !node.hidden);
      const sameRow = offers.length === 2 && Math.abs(offers[0].getBoundingClientRect().top - offers[1].getBoundingClientRect().top) < 8;
      this.toggleAttribute('data-same-row', sameRow);
    }
    offer(provider, node) {
      const host = element('div', { class: `gp-bnpl__offer gp-bnpl__offer--${provider}`, 'data-provider': provider });
      host.append(node); this.append(host); return host;
    }
    update() {
      clearInterval(this.readyTimer);
      this.replaceChildren();
      const amount = Number(this.dataset.amount);
      const region = this.dataset.region;
      if (!Number.isInteger(amount) || amount <= 0 || currencies[region] !== this.dataset.currency) return;
      if (region === 'au' && this.dataset.flexibleCopy && this.dataset.afterpayLogo && this.dataset.zipLogo) {
        if (amount < 100 || amount > 500000) return;
        const row = element('div', { class: 'gp-bnpl__offer gp-bnpl__offer--options', 'data-ready': '' });
        const copy = document.createElement('span');
        copy.textContent = this.dataset.flexibleCopy;
        row.append(copy);
        if (amount <= 400000) {
          row.append(element('img', {
            src: this.dataset.afterpayLogo, alt: 'Afterpay', width: '61', height: '12', 'data-provider': 'afterpay'
          }));
          if (this.dataset.logoJoiner) {
            const joiner = document.createElement('span');
            joiner.textContent = this.dataset.logoJoiner;
            row.append(joiner);
          }
        }
        row.append(element('img', {
          src: this.dataset.zipLogo, alt: 'Zip', width: '32', height: '12', 'data-provider': 'zip'
        }));
        this.append(row);
        return;
      }
      const dollars = (amount / 100).toFixed(2);
      if ((region === 'au' || region === 'nz') && amount >= 100 && amount <= 400000) {
        this.offer('afterpay', element('square-placement', {
          'data-mpid': this.dataset.shop, 'data-platform': 'shopify-snippet', 'data-page-type': 'product',
          'data-currency': this.dataset.currency, 'data-consumer-locale': region === 'au' ? 'en_AU' : 'en_NZ',
          'data-amount': dollars, 'data-item-skus': this.dataset.sku || '',
          'data-show-if-outside-limits': 'false', 'data-payment-amount-is-bold': 'false',
          'data-show-interest-free': 'false', 'data-intro-text': 'or', 'data-show-with': 'false',
          'data-size': 'sm', 'data-logo-type': 'lockup', 'data-lockup-theme': 'black'
        }));
        loadScript('https://js.squarecdn.com/square-marketplace.js').catch(() => {});
      }
      if (region === 'au' && amount >= 100 && amount <= 500000) {
        const zip = element('div', {
          'data-zm-merchant': '7125ddf4-c4bd-4631-b973-2b056ad2b65b', 'data-zm-price': dollars,
          'data-zm-shopify-logic': 'false', 'data-zm-asset': 'productwidget', 'data-zm-widget': 'popup',
          'data-zm-popup-asset': 'termsdialog', 'data-zm-region': 'au', 'data-env': 'production',
          role: 'button', tabindex: '0', 'aria-label': 'Zip payment options and terms'
        });
        zip.addEventListener('keydown', event => {
          if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); zip.click(); }
        });
        this.offer('zip', zip);
        loadScript('https://static.zip.co/lib/js/zm-widget-js/dist/zip-widget.min.js').catch(() => {});
      }
      if (region === 'uk') {
        this.offer('klarna', element('klarna-placement', {
          'data-key': 'credit-promotion-auto-size', 'data-locale': 'en-GB', 'data-purchase-amount': amount
        }));
        loadScript('https://js.klarna.com/web-sdk/v1/klarna.js', { 'data-client-id': 'a1951f33-5a7a-5cd7-be14-1e56bb6854a6' })
          .then(() => window.Klarna?.OnsiteMessaging?.refresh?.()).catch(() => {});
      }
      if (region === 'usa') {
        this.offer('affirm', element('p', {
          class: 'affirm-as-low-as', 'data-amount': amount, 'data-page-type': this.dataset.context === 'grid' ? 'category' : 'product',
          'data-learnmore-show': 'false'
        }));
        refreshAffirm();
      }
      let attempts = 0;
      this.readyTimer = setInterval(() => {
        if (!this.isConnected) { clearInterval(this.readyTimer); return; }
        this.querySelectorAll('.gp-bnpl__offer').forEach(host => {
          const slot = host.firstElementChild;
          const provider = host.dataset.provider;
          const message = provider === 'afterpay' ? slot.shadowRoot?.querySelector('.afterpay-paragraph')
            : provider === 'klarna' ? slot.shadowRoot?.querySelector('.loaded [part="osm-message"]')
            : provider === 'zip' ? slot.querySelector('.zip-container') : slot;
          const copy = message?.textContent.replace(/\s+/g, ' ').trim() || '';
          // Generic 'pay later' / 'orders over $50' banners do not confirm a price-eligible offer.
          const quoted = provider === 'klarna' ? /(?:\d+ payments of\s*£|£[\d.,]+.*(?:month|\/mo))/i.test(copy)
            : provider === 'affirm' ? /(?:(?:starting at|as low as)\s*\$\d|\d+ interest-free payments(?: of\s*\$\d)?)/i.test(copy)
            : Boolean(copy);
          host.toggleAttribute('data-ready', quoted);
        });
        this.align();
        if (++attempts >= 150 || [...this.querySelectorAll('.gp-bnpl__offer')].every(host => host.hasAttribute('data-ready'))) clearInterval(this.readyTimer);
      }, 200);
    }
  }
  customElements.define('gp-bnpl', GrowplayBnpl);
})();
